module.exports = __webpack_public_path__ + "img/getafe-logo-icon.f2956e01.png";